// assets/find-your-pomade.js
/**
 * Basix "Find Your Pomade" Quiz
 * Lightweight, accessible quiz for product recommendations
 * With GA4 tracking
 */

(function() {
  'use strict';

  // ===== GA4 Helper =====
  const QUIZ_NAME = "find_your_pomade";
  const QUIZ_VERSION = "v1";

  function ga4(eventName, params = {}) {
    try {
      // Primary: gtag (direct GA4 install)
      if (typeof window.gtag === "function") {
        window.gtag("event", eventName, params);
        return;
      }

      // Fallback: dataLayer (if GTM is present)
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: eventName, ...params });
    } catch (e) {
      // swallow errors; do not break quiz UX
    }
  }

  // ===== Configuration =====
  const CONFIG = {
    products: {
      clay: {
        name: 'Basix Clay Pomade',
        handle: 'clay-pomade',
        variantId: null,
        reason: 'Best for textured, matte styles with firm all-day hold.'
      },
      cream: {
        name: 'Basix Cream Pomade',
        handle: 'cream-pomade',
        variantId: null,
        reason: 'Perfect for natural, effortless looks with light, flexible hold.'
      },
      paste: {
        name: 'Basix Paste Pomade',
        handle: 'paste-pomade',
        variantId: null,
        reason: 'Ideal for structured, controlled styles with strong hold.'
      },
      powder: {
        name: 'Basix Hair Styling Powder',
        handle: 'hair-styling-powder',
        variantId: null,
        reason: 'Maximum volume and texture for hair that needs serious lift.'
      }
    },
    collectionUrl: '/collections/everyday-essentials-hair',
    // Set to true to redirect immediately, false to show results on page
    immediateRedirect: false,
    // Set to false if powder is sold out
    powderAvailable: true
  };

  // ===== State =====
  let quizStarted = false;

  // ===== DOM Elements =====
  const elements = {
    form: document.getElementById('pomade-quiz-form'),
    results: document.getElementById('quiz-results'),
    submitBtn: document.querySelector('.quiz-cta'),
    progressCurrent: document.querySelector('.progress-current'),
    progressTotal: document.querySelector('.progress-total'),
    conditionalQ4: document.querySelector('[data-question="4"]'),
    resultTitle: document.getElementById('result-product-name'),
    resultReason: document.getElementById('result-reason'),
    ctaPrimary: document.getElementById('result-cta-primary'),
    ctaAddon: document.getElementById('result-cta-addon'),
    restartBtn: document.getElementById('quiz-restart'),
    collectionLink: document.querySelector('.result-link')
  };

  // ===== Recommendation Logic =====
  function getRecommendation(answers) {
    const { thickness, length, look, volumeIssue } = answers;
    
    let primary = null;
    let addon = null;

    // Primary recommendation logic
    if (look === 'volume') {
      primary = 'powder';
    } else if (thickness === 'thin') {
      if (look === 'natural') {
        primary = 'cream';
      } else if (look === 'textured') {
        primary = 'clay';
      } else if (look === 'structured') {
        primary = 'clay'; // Guardrail: paste may be too heavy for thin hair
      }
    } else if (thickness === 'normal') {
      if (look === 'natural') {
        primary = 'cream';
      } else if (look === 'textured') {
        primary = 'clay';
      } else if (look === 'structured') {
        primary = 'paste';
      }
    } else if (thickness === 'thick') {
      if (look === 'structured') {
        primary = 'paste';
      } else {
        primary = 'clay';
      }
    }

    // Length guardrail
    if (length === 'long' && primary === 'powder') {
      primary = 'cream'; // Powder less ideal as primary for long hair
    }

    // Add-on logic (powder as enhancer for thin hair with volume issues)
    if (CONFIG.powderAvailable && thickness === 'thin' && 
        (volumeIssue === 'yes' || volumeIssue === 'sometimes')) {
      if (primary !== 'powder') {
        addon = 'powder';
      }
    }

    // Fallback
    if (!primary) {
      primary = 'clay';
    }

    return { primary, addon };
  }

  // ===== URL Builders =====
  function getProductUrl(productKey) {
    const product = CONFIG.products[productKey];
    return `/products/${product.handle}`;
  }

  function getCartUrl(primaryKey, addonKey) {
    const primary = CONFIG.products[primaryKey];
    const addon = CONFIG.products[addonKey];
    
    if (!primary.variantId || !addon.variantId) {
      // Fall back to product page if variant IDs not configured
      return getProductUrl(primaryKey);
    }
    
    return `/cart/${primary.variantId}:1,${addon.variantId}:1`;
  }

  // ===== Form Handling =====
  function getFormAnswers() {
    const formData = new FormData(elements.form);
    return {
      thickness: formData.get('thickness'),
      length: formData.get('length'),
      look: formData.get('look'),
      volumeIssue: formData.get('volumeIssue')
    };
  }

  function countAnswered() {
    const answers = getFormAnswers();
    let count = 0;
    if (answers.thickness) count++;
    if (answers.length) count++;
    if (answers.look) count++;
    if (!elements.conditionalQ4.hidden && answers.volumeIssue) count++;
    return count;
  }

  function getRequiredCount() {
    return elements.conditionalQ4.hidden ? 3 : 4;
  }

  function updateProgress() {
    const answered = countAnswered();
    const total = getRequiredCount();
    
    elements.progressCurrent.textContent = answered;
    elements.progressTotal.textContent = total;
    
    // Enable/disable submit button
    elements.submitBtn.disabled = answered < total;
  }

  // ===== Event Handlers =====
  function handleQuizStart() {
    if (!quizStarted) {
      quizStarted = true;
      ga4("quiz_start", {
        quiz_name: QUIZ_NAME,
        quiz_version: QUIZ_VERSION
      });
      console.log('[Pomade Quiz] quiz_start fired');
    }
  }

  function handleAnswerChange(e) {
    // Fire quiz_start on first interaction
    handleQuizStart();

    // Get question and answer info
    const input = e.target;
    if (input.type !== 'radio') return;

    const fieldset = input.closest('fieldset');
    const questionId = 'q' + fieldset.dataset.question;
    const answerId = input.value;

    // Fire quiz_answer event
    ga4("quiz_answer", {
      quiz_name: QUIZ_NAME,
      quiz_version: QUIZ_VERSION,
      question_id: questionId,
      answer_id: answerId
    });
    console.log('[Pomade Quiz] quiz_answer fired:', questionId, answerId);

    // Update progress
    updateProgress();
  }

  function handleThicknessChange(e) {
    const isThin = e.target.value === 'thin';
    
    if (isThin) {
      elements.conditionalQ4.hidden = false;
    } else {
      elements.conditionalQ4.hidden = true;
      // Clear Q4 answer if hiding
      const q4Inputs = elements.conditionalQ4.querySelectorAll('input');
      q4Inputs.forEach(input => input.checked = false);
    }
    
    updateProgress();
  }

  function showResults(primary, addon) {
    const product = CONFIG.products[primary];
    const productUrl = getProductUrl(primary);
    
    // Update result content
    elements.resultTitle.textContent = product.name;
    elements.resultReason.textContent = product.reason;
    elements.ctaPrimary.href = productUrl;
    
    // Update collection link
    if (elements.collectionLink) {
      elements.collectionLink.href = CONFIG.collectionUrl;
    }
    
    // Handle add-on button
    if (addon && CONFIG.powderAvailable) {
      elements.ctaAddon.hidden = false;
      elements.ctaAddon.href = getCartUrl(primary, addon);
    } else {
      elements.ctaAddon.hidden = true;
    }
    
    // Hide form, show results
    elements.form.hidden = true;
    elements.results.hidden = false;
    
    // Fire quiz_result event
    ga4("quiz_result", {
      quiz_name: QUIZ_NAME,
      quiz_version: QUIZ_VERSION,
      result_id: primary + '_pomade',
      result_name: product.name,
      addon_id: addon ? addon + '_powder' : 'none'
    });
    console.log('[Pomade Quiz] quiz_result fired:', primary);
    
    // Scroll to results
    elements.results.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function handleSubmit(e) {
    e.preventDefault();
    
    const answers = getFormAnswers();
    const { primary, addon } = getRecommendation(answers);
    
    // Fire quiz_complete event
    ga4("quiz_complete", {
      quiz_name: QUIZ_NAME,
      quiz_version: QUIZ_VERSION,
      answers: {
        thickness: answers.thickness,
        length: answers.length,
        look: answers.look,
        volume_issue: answers.volumeIssue || 'not_asked'
      }
    });
    console.log('[Pomade Quiz] quiz_complete fired');
    
    if (CONFIG.immediateRedirect) {
      const redirectUrl = addon ? getCartUrl(primary, addon) : getProductUrl(primary);
      window.location.href = redirectUrl;
    } else {
      showResults(primary, addon);
    }
  }

  function handleCtaClick(e) {
    const link = e.currentTarget;
    const destination = link.href;
    const isPrimary = link.id === 'result-cta-primary';
    
    ga4("quiz_cta_click", {
      quiz_name: QUIZ_NAME,
      quiz_version: QUIZ_VERSION,
      cta_type: isPrimary ? 'shop_now' : 'add_powder',
      destination: destination
    });
    console.log('[Pomade Quiz] quiz_cta_click fired:', destination);
  }

  function handleCollectionLinkClick(e) {
    ga4("quiz_cta_click", {
      quiz_name: QUIZ_NAME,
      quiz_version: QUIZ_VERSION,
      cta_type: 'see_all_products',
      destination: CONFIG.collectionUrl
    });
    console.log('[Pomade Quiz] quiz_cta_click (collection) fired');
  }

  function handleRestart() {
    // Reset form
    elements.form.reset();
    
    // Hide conditional question
    elements.conditionalQ4.hidden = true;
    
    // Reset state
    quizStarted = false;
    
    // Update UI
    updateProgress();
    
    // Show form, hide results
    elements.form.hidden = false;
    elements.results.hidden = true;
    
    // Scroll to top of quiz
    document.getElementById('pomade-quiz').scrollIntoView({ behavior: 'smooth', block: 'start' });
    
    console.log('[Pomade Quiz] Quiz restarted');
  }

  // ===== Initialization =====
  function init() {
    if (!elements.form) {
      console.warn('[Pomade Quiz] Form not found');
      return;
    }

    // Load variant IDs from data attributes if present
    const quizSection = document.getElementById('pomade-quiz');
    if (quizSection) {
      const clayId = quizSection.dataset.clayVariantId;
      const creamId = quizSection.dataset.creamVariantId;
      const pasteId = quizSection.dataset.pasteVariantId;
      const powderId = quizSection.dataset.powderVariantId;
      
      if (clayId) CONFIG.products.clay.variantId = clayId;
      if (creamId) CONFIG.products.cream.variantId = creamId;
      if (pasteId) CONFIG.products.paste.variantId = pasteId;
      if (powderId) CONFIG.products.powder.variantId = powderId;
    }

    // Event listeners
    elements.form.addEventListener('change', handleAnswerChange);
    elements.form.addEventListener('submit', handleSubmit);
    
    // Thickness change listener for conditional Q4
    const thicknessInputs = elements.form.querySelectorAll('input[name="thickness"]');
    thicknessInputs.forEach(input => {
      input.addEventListener('change', handleThicknessChange);
    });
    
    // CTA click tracking
    if (elements.ctaPrimary) {
      elements.ctaPrimary.addEventListener('click', handleCtaClick);
    }
    if (elements.ctaAddon) {
      elements.ctaAddon.addEventListener('click', handleCtaClick);
    }
    if (elements.collectionLink) {
      elements.collectionLink.addEventListener('click', handleCollectionLinkClick);
    }
    
    // Restart button
    if (elements.restartBtn) {
      elements.restartBtn.addEventListener('click', handleRestart);
    }

    // Initial state
    updateProgress();
    
    console.log('[Pomade Quiz] Initialized with GA4 tracking');
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();